import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAuthToken } from "../store/selectors/AuthSelectors";
import ApiService from "../services/AxiosInstance";

export const useDegrees = (year) => {
  const [degrees, setDegrees] = useState([]);
  const token = useSelector(selectAuthToken);

  const fetchDegrees = async (y) => {
    try {
      const response = await ApiService.get("/degree", {
        headers: { Authorization: `Bearer ${token}` },
        params: { year: y || year },
      });
      setDegrees(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching degrees:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchDegrees(year);
    }
  }, [year, token]);

  return { degrees, fetchDegrees };
};
